import PaginationStyles from "./Pagination.module.scss";
import firstPage from "../../assets/images/firstPage.svg";
import firstPageDisabled from "../../assets/images/firstPageDisabled.svg";
import nextPage from "../../assets/images/nextPage.svg";
import nextPageDisabled from "../../assets/images/nextPageDisabled.svg";
import prevPage from "../../assets/images/prevPage.svg";
import prevPageDisabled from "../../assets/images/prevPageDisabled.svg";
import lastPage from "../../assets/images/lastPage.svg";
import lastPageDisabled from "../../assets/images/lastPageDisabled.svg";
import { Select } from "antd";
import {
  TableTypes,
  PaginationActions,
} from "../../modules/ManageContract/constants";
import { useAppSelector } from "../../hooks/store";

export const Pagination = ({
  type = "default",
  entity,
  count,
  page,
  tableObject,
  handleButtonClick,
  handleCountChange,
  className
}: any) => {
  const handleChange = (value: number) => {
    handleCountChange(value);
  };
  const data = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer?.data
  );

  const toBeRetrieved = data?.[entity]?.toBeRetrieved;
  return (
    <>
      {/* {type !== "default" ? (
        <div className={PaginationStyles.paginate}>
          <div className={PaginationStyles.info}>
            <span>
              {count * (page - 1) + 1}-
              {page * count + tableObject?.results?.length - count} of{" "}
              {tableObject?.count}
            </span>
          </div>
          <div className={PaginationStyles.buttons}>
            <div className={PaginationStyles.firstPage}>
              {tableObject.previous == null ? (
                <img src={firstPageDisabled} alt="" />
              ) : (
                <img
                  src={firstPage}
                  onClick={() => handleButtonClick("First")}
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.prevPage}>
              {tableObject.previous == null ? (
                <img src={prevPageDisabled} alt="" />
              ) : (
                <img
                  src={prevPage}
                  onClick={() => handleButtonClick("Previous")}
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.nextPage}>
              {tableObject.next == null ? (
                <img src={nextPageDisabled} alt="" />
              ) : (
                <img
                  src={nextPage}
                  onClick={() => handleButtonClick("Next")}
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.lastPage}>
              {tableObject.next == null ? (
                <img src={lastPageDisabled} alt="" />
              ) : (
                <img
                  src={lastPage}
                  onClick={() => handleButtonClick("Last")}
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={PaginationStyles.paginateAdvance}>
          <div className="count">
            <span>
              Total{" "}
              {entity === TableTypes.USER_MANAGEMENT ? "Users" : "Contracts"}:{" "}
              {tableObject?.count}
            </span>
          </div>
          <div className={PaginationStyles.right}>
            <div className={PaginationStyles.dropdown}>
              <span>Rows per page</span>
              <Select
                className={PaginationStyles.dropdownSelect}
                onChange={handleChange}
                disabled={data?.[entity]?.newDataRequested}
                defaultValue={toBeRetrieved ? toBeRetrieved : 10}
                options={[
                  { value: 10, label: <span>10</span> },
                  { value: 20, label: <span>20</span> },
                  { value: 30, label: <span>30</span> },
                  { value: 40, label: <span>40</span> },
                  { value: 50, label: <span>50</span> },
                  { value: 60, label: <span>60</span> },
                ]}
              />
            </div>

            <div className={PaginationStyles.info}>
              <span>
                {count * (page - 1) + 1}-
                {page * count + tableObject?.results?.length - count} of{" "}
                {tableObject?.count}
              </span>
            </div>
            <div className={PaginationStyles.buttons}>
              <div className={PaginationStyles.firstPage}>
                {tableObject.previous == null ? (
                  <img src={firstPageDisabled} alt="" />
                ) : (
                  <img
                    src={firstPage}
                    onClick={() => handleButtonClick(PaginationActions.FIRST)}
                    alt=""
                  />
                )}
              </div>
              <div className={PaginationStyles.prevPage}>
                {tableObject.previous == null ? (
                  <img src={prevPageDisabled} alt="" />
                ) : (
                  <img
                    src={prevPage}
                    onClick={() =>
                      handleButtonClick(PaginationActions.PREVIOUS)
                    }
                    alt=""
                  />
                )}
              </div>
              <div className={PaginationStyles.nextPage}>
                {tableObject.next == null ? (
                  <img src={nextPageDisabled} alt="" />
                ) : (
                  <img
                    src={nextPage}
                    onClick={() => handleButtonClick(PaginationActions.NEXT)}
                    alt=""
                  />
                )}
              </div>
              <div className={PaginationStyles.lastPage}>
                {tableObject.next == null ? (
                  <img src={lastPageDisabled} alt="" />
                ) : (
                  <img
                    src={lastPage}
                    onClick={() => handleButtonClick(PaginationActions.LAST)}
                    alt=""
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )} */}
      <div className={`${PaginationStyles.paginateAdvance} ${className}`}>
        <div className="count">
          <span>
            Total{" "}
            {entity === TableTypes.USER_MANAGEMENT ? "Users" : entity === TableTypes.RFX_EVALUATION_DASHBOARD ? "RFx" : "Contracts"}:{" "}
            {tableObject?.count}
          </span>
        </div>
        <div className={PaginationStyles.right}>
          <div className={PaginationStyles.dropdown}>
            <span>Rows per page</span>
            <Select
              className={PaginationStyles.dropdownSelect}
              onChange={handleChange}
              disabled={data?.[entity]?.newDataRequested}
              defaultValue={toBeRetrieved ? toBeRetrieved : 10}
              options={[
                { value: 10, label: <span>10</span> },
                { value: 20, label: <span>20</span> },
                { value: 30, label: <span>30</span> },
                { value: 40, label: <span>40</span> },
                { value: 50, label: <span>50</span> },
                { value: 60, label: <span>60</span> },
              ]}
            />
          </div>

          <div className={PaginationStyles.info}>
            <span>
              {count * (page - 1) + 1}-
              {page * count + tableObject?.results?.length - count} of{" "}
              {tableObject?.count}
            </span>
          </div>
          <div className={PaginationStyles.buttons}>
            <div className={PaginationStyles.firstPage}>
              {tableObject.previous == null ? (
                <img src={firstPageDisabled} alt="" />
              ) : (
                <img
                  src={firstPage}
                  onClick={() => handleButtonClick(PaginationActions.FIRST)}
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.prevPage}>
              {tableObject.previous == null ? (
                <img src={prevPageDisabled} alt="" />
              ) : (
                <img
                  src={prevPage}
                  onClick={() =>
                    handleButtonClick(PaginationActions.PREVIOUS)
                  }
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.nextPage}>
              {tableObject.next == null ? (
                <img src={nextPageDisabled} alt="" />
              ) : (
                <img
                  src={nextPage}
                  onClick={() => handleButtonClick(PaginationActions.NEXT)}
                  alt=""
                />
              )}
            </div>
            <div className={PaginationStyles.lastPage}>
              {tableObject.next == null ? (
                <img src={lastPageDisabled} alt="" />
              ) : (
                <img
                  src={lastPage}
                  onClick={() => handleButtonClick(PaginationActions.LAST)}
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
